import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_instance_edit = _resolveComponent("ontos-instance-edit")!
  const _component_ontos_unsaved_changes_dialog = _resolveComponent("ontos-unsaved-changes-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    ref: "base",
    "phone-flush": ""
  }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_ontos_instance_edit, {
            key: 0,
            context: _ctx.$route.params,
            idea: _ctx.idea,
            instance: _ctx.instance,
            domains: _ctx.domains,
            "choice-domains": _ctx.workspace.domains,
            "reverse-info": _ctx.reverseInfo,
            original: _ctx.original,
            onSaved: _ctx.onSaved,
            onShowMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showMessage', $event))),
            onShowErrorMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
          }, {
            controls: _withCtx(({dirty}) => [
              _createVNode(_component_ontos_header_action, {
                icon: "mdi-arrow-left",
                label: _ctx.$tt('back'),
                onClick: ($event: any) => (_ctx.onBack(dirty))
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["context", "idea", "instance", "domains", "choice-domains", "reverse-info", "original", "onSaved"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ontos_unsaved_changes_dialog, {
        leaving: _ctx.leaving,
        onConfirmed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToView())),
        onCancelled: _cache[3] || (_cache[3] = ($event: any) => (_ctx.leaving = null))
      }, null, 8, ["leaving"])
    ]),
    _: 1
  }, 16))
}